module.exports = __webpack_public_path__ + "img/tablet-40cm.a967db2c.svg";